// extracted by mini-css-extract-plugin
export default {"switch":"SyOt1KLkKiwr7pYyG7K0"};